module.exports = __webpack_public_path__ + "static/media/rocket_takeoff.af1ab3ac.svg";